
import { footer } from '../../customWhiteLabel'

export default {
  data() {
    return {
      footer,
    }
  },

  methods: {
    renovarCertificado() {
      const whatsappUrl = `https://wa.me/${
        this.footer.botaoRenocao
      }?text=${encodeURIComponent(this.footer.messageRenovacaoSispass)}`
      window.open(whatsappUrl, '_blanck')
    },
  },
}
